import React, { Component } from 'react';
import { connect } from "react-redux";
import PowerbiEmbedded from "react-powerbi";
import {
    fetchReports
} from '../../../../store/actions/reportsAction'

class JBSClaimsLogComponent extends Component{
    constructor(props){
        super(props);
        this.props.fetchReports('120f09b3-fed2-4cd9-9504-ae4331d047ee');
        this.state = {
            reportID: '120f09b3-fed2-4cd9-9504-ae4331d047ee',
            user: this.props.user,
             token: {}
        }
        const {user, reportID} = this.state;
        user && this.props.fetchReports({reportID, user});
    }

    componentWillReceiveProps(nextProps, prevProps){
        if(nextProps.token){
            if(nextProps.token !== this.state.token){
                this.setState({
                    token: nextProps.token,
                    user: nextProps.user
                });
                
            }
        }
    }

    render(){
        const { token, user } = this.state;
        const { reportID } = this.state;
        return(
            <div style={{width: '100%', padding: 0, height: 'calc( 100vh - 60px )'}}>
                {token && <PowerbiEmbedded
                    id={`${reportID}`}
                    userId={ user.userId }
                    embedUrl={token.embedUrl}
                    accessToken={token.accessToken}
                    filterPaneEnabled={true}
                    navContentPaneEnabled={true}
                    tokenType='Embed'
                    width="100%"
                    height="100%"
                    onEmbedded={this.onEmbedded}
                />}
            </div>
        )
    }
}

const mapStateToProps = state => ({
    token: state.token.token,
    user: state.auth.user
})

export default connect(mapStateToProps, {
    fetchReports
})(JBSClaimsLogComponent);